import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-021fd899")

_pushScopeId("data-v-021fd899")
const _hoisted_1 = { class: "char-card" }
const _hoisted_2 = { class: "char-card-wrap" }
const _hoisted_3 = {
  key: 0,
  class: "real-tag"
}
const _hoisted_4 = { class: "bottom" }
const _hoisted_5 = { class: "start-wrap" }
const _hoisted_6 = { class: "name-wrap" }
const _hoisted_7 = { class: "ring" }
const _hoisted_8 = { class: "intro" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("a", {
        href: "javascript:;",
        class: _ctx.bgColor
      }, [
        _createVNode("img", {
          src: _ctx.charListImg,
          class: "char-img",
          alt: _ctx.$t(_ctx.name)
        }, null, 8, ["src", "alt"]),
        _createVNode("div", {
          class: ["category-wrap", _ctx.bgColor]
        }, [
          _createVNode("span", {
            class: ["category", _ctx.category]
          }, null, 2)
        ], 2),
        (_ctx.isReal)
          ? (_openBlock(), _createBlock("div", _hoisted_3, _toDisplayString(_ctx.$t('realBody')), 1))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.startInfo.num, (item) => {
              return (_openBlock(), _createBlock("em", {
                class: ["start", _ctx.startInfo.color],
                key: item
              }, null, 2))
            }), 128))
          ]),
          _createVNode("div", _hoisted_6, [
            _createVNode("p", {
              class: ["name", _ctx.$nowLang]
            }, _toDisplayString(_ctx.$t(_ctx.name)), 3)
          ])
        ])
      ], 2),
      _createVNode("p", _hoisted_7, _toDisplayString(_ctx.ring), 1),
      _createVNode("p", _hoisted_8, _toDisplayString(_ctx.ringDetail), 1)
    ])
  ]))
})